<template>
    <section class="col s12">

        <!-- VALIDAÇÃO DO ITEM -->
        <div class="row">
            <div class="col s12">
                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="acao_eliminada_concorrente_validacao_selecionada"
                               class="with-gap"
                               type="radio"
                               id="rdNaoAEC"
                               :disabled="allDisabled"
                               value="nao"
                               v-model="validacaoSelecionada" />
                        <span>Não</span>
                    </label>
                </div>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="acao_eliminada_concorrente_validacao_selecionada"
                               class="with-gap"
                               type="radio"
                               id="rdEliminadoAEC"
                               :disabled="allDisabled"
                               value="eliminado"
                               v-model="validacaoSelecionada" />
                        <span>Eliminado</span>
                    </label>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
export default {
    name: "at_acao_eliminada_concorrente",
    props: {
        pValidacaoSelecionada: {
            type: String,
            default: null,
        },
        allDisabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            validacaoSelecionada: this.pValidacaoSelecionada,
        }
    },
    watch: {
        pValidacaoSelecionada(newValue) {
            this.validacaoSelecionada = newValue
        },
        validacaoSelecionada(newValue) {
            this.$emit('update:pValidacaoSelecionada', newValue)
        },
    },
}
</script>

<style scoped>

</style>
